import {Model} from '@/models/Model'
import {DataProductPromotionsArray, ProductPromotion} from '@/models/ProductPromotion'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const PromotionConst = Object.freeze({
  TYPE_TEST: 20,

  map(status: number): string {
    switch (status) {
      case PromotionConst.TYPE_TEST:
        return 'Test'
    }
    return ''
  },
})


export const PromotionGroupConst = Object.freeze({

  map(group: number): string {
    const group_name = {
      1: 'ออนไลน์',
      2: 'หน้าร้าน/เพจ',
      3: 'โปรฯอีสาน',
      4: 'โปรฯหลงจง',
      5: 'โปรฯ TT',
      6: 'โปรฯ PJ',
      7: 'โปรฯ PJ เอกชน',
      8: 'OFM',
      9: 'KCCP',
      10: 'KCCP+5%',
      11: 'แลกแต้ม',
    }

    return group_name[group]
  },
})

//
// {{ item.promotion_type === 'S' ? 'ซื้อเป็นชุด' : '' }}
// {{ item.promotion_type === 'D' ? 'ผสมคละสินค้า' : '' }}
// {{ item.promotion_type === 'T' ? 'ลดราคา' : '' }}




export class Promotion extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  campaign_id: number
  price_group: number | null
  enabled: boolean | null
  stock: number | null
  cache_stock: number | string | null
  total_price: number
  amount_sold: number | null
  amount_limit: number | null

  promotion_type: string

  product_promotions: ProductPromotion[]
  discount_mode: string | null
  discount_percent: number | null
  discount_amount: number | null

  getResourceURL(): string {
    return Helper.setting.promotion.getResourceAPI
  }


  public static calStock(promotion: Promotion): number | string {
    if (promotion.amount_limit && promotion.amount_sold!==null)
      return promotion.amount_limit - promotion.amount_sold

    if (promotion.cache_stock != null) return promotion.cache_stock

    if (promotion.amount_limit === 0) {
      let min_stock = 999

      if (promotion.product_promotions && promotion.product_promotions.length > 0) {
        for (let i in promotion.product_promotions) {
          const product_promotion = promotion.product_promotions[i]
          if (product_promotion && product_promotion.quantity && product_promotion.product && product_promotion.product.stock_MT) {
            min_stock = Math.min(min_stock, product_promotion.product.stock_MT / product_promotion.quantity)
          } else {
            promotion.cache_stock = 'n/a'
            return 'n/a'
          }
        }
        return Math.floor(min_stock)
      }
    }
    promotion.cache_stock = 'n/a'
    return 'n/a'
  }


  public async loadProducts(): Promise<DataProductPromotionsArray> {
    return await new Promise<DataProductPromotionsArray>((resolve, reject) => {
      Helper.get(Helper.setting.promotion.getPromotionAPI.replace('{id}', this.id))
        .then<{ data: DataProductPromotionsArray }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }

}

export class DataPromotionsArray extends DataArray {

  declare data: Promotion[]
  filter: FilterPromotion = new FilterPromotion()
}


export class FilterPromotion {
  price_group: FilterSet = new FilterSet()
}


export class DataPromotion extends DataResource {

  declare data: Promotion

}
